/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-06-20",
    versionChannel: "nightly",
    buildDate: "2025-06-20T00:07:07.090Z",
    commitHash: "157f8e0a0aa4b6dd6189a3a2a10d427110071028",
};
